import {
  BusinessChallengesEnum,
  OrganizationApplicationParameters,
} from '@platform/client/schemas';
import { FormsInputDropdown, FormsMultilineInput } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import BackgroundImage from '../../images/Section9.png';
import { challengeOptions } from './OrgFirstChallengeSelection';

type FormValues = {
  thirdBusinessChallenge: BusinessChallengesEnum;
  thirdBusinessChallengeDescription?: string;
};

export const OrgThirdChallengeSelection = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress, isEditProfile = false } = { ...props };

  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<OrganizationApplicationParameters>();

  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      thirdBusinessChallenge: getApplicationDataByKey('thirdBusinessChallenge'),
      thirdBusinessChallengeDescription: getApplicationDataByKey(
        'thirdBusinessChallengeDescription',
      ),
    },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    updateApplicationData({
      thirdBusinessChallenge: data.thirdBusinessChallenge,
      thirdBusinessChallengeDescription: data.thirdBusinessChallengeDescription,
    });
    onContinue();
  };

  const handleBack = () => {
    updateApplicationData({
      thirdBusinessChallenge: watch('thirdBusinessChallenge'),
      thirdBusinessChallengeDescription: watch('thirdBusinessChallengeDescription'),
    });
    onBack();
  };

  return (
    <ApplicationBackground
      progress={progress}
      isOrganization={true}
      onBack={handleBack}
      onSubmit={handleSubmit(submit)}
      backgroundImage={BackgroundImage}
      isEditProfile={isEditProfile}
    >
      <ApplicationPageContent title='Tell us about your third biggest challenge'>
        <FormsInputDropdown
          control={control}
          name='thirdBusinessChallenge'
          rules={{ required: 'Select a challenge your organization needs help with to continue' }}
          label='Third business challenge'
          placeholder='Select your third challenge'
          items={challengeOptions}
          type='default'
          error={errors.thirdBusinessChallenge}
        />
        <FormsMultilineInput
          control={control}
          label='Tell us more about this challenge'
          placeholder='Enter a description...'
          name={'thirdBusinessChallengeDescription'}
          rules={{ maxLength: 500, required: 'Tell us more about this challenge to continue' }}
          formsError={errors.thirdBusinessChallengeDescription}
          characterCount={500}
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
